<template>
  <div class="p-col-12">
			<div class="card">
          <h5>Roles</h5>
           <DataTable :value="items" scrollHeight="400px" 
                      :loading="loading2" scrollDirection="both" class="p-mt-3" >
                    <Column field="name" header="Name"></Column>     
                     
          </DataTable>
			</div>
	</div>
</template>

<script>

import { apiGet } from '../../helpers/rest-api'


export default {

   data () {
     return {
       items : []
     }
   },
   mounted () {
      this.getAll()
    },

    methods : {
        getAll() {
          apiGet('rol')
            .then(response => (this.items = response.data))
        },
  }
}
</script>

<style scoped lang="scss">

.cursor {
    cursor : pointer
}

.empresa-badge {
		border-radius: 2px;
		padding: .25em .5rem;
		text-transform: uppercase;
		font-weight: 700;
		font-size: 12px;
		letter-spacing: .3px;

		&.status-active {
			background: #C8E6C9;
			color: #256029;
		}

		&.status-inactive {
			background: #FFCDD2;
			color: #C63737;
		}
	}

</style>


 
  
